import { StarIcon } from "lucide-react"
import { toast } from "sonner"
import { TooltipButton } from "~/components/ui/button"
import { cn } from "~/lib/utils"
import { api } from "~/trpc/react"

export function IssueFavoriteButton({
	issueId,
	teamId
}: {
	issueId: string
	teamId: string
}) {
	const utils = api.useUtils()
	const state = api.favorites.getIssueState.useQuery(
		{ issueId, teamId },
		{ enabled: !!issueId && !!teamId }
	)
	const update = api.favorites.setIssueState.useMutation({
		onSuccess: () =>
			Promise.all([
				utils.favorites.getIssueState.invalidate({ issueId, teamId }),
				utils.favorites.list.invalidate()
			]),
		onError: (error) => toast.error(error.message)
	})
	const favorited = state.data?.favorited ?? false
	return (
		<TooltipButton
			variant="outline"
			size="icon"
			tooltip={favorited ? "Remove from favourites" : "Add to favourites"}
			aria-pressed={favorited}
			disabled={state.isLoading || state.isError || update.isPending}
			onClick={() => update.mutate({ issueId, teamId, favorited: !favorited })}
		>
			<StarIcon
				className={cn("size-4", favorited && "fill-yellow-300 text-yellow-300")}
			/>
		</TooltipButton>
	)
}
